"use client";

import { Box, Typography } from "@repo/ui";

type LoadingProps = {
  message?: string;
  className?: string;
  style?: React.CSSProperties;
};

const Loading = ({
  message = "Loading...",
  className = "",
  style,
}: LoadingProps) => {
  return (
    <Box
      className={`flex flex-col items-center justify-center p-8 ${className}`}
      style={style}
    >
      <div className="relative w-16 h-16 mb-4">
        {/* Outer ring */}
        <div className="absolute w-full h-full border-4 border-primary-light rounded-full"></div>
        {/* Spinning ring */}
        <div className="absolute w-full h-full border-4 border-t-primary-main rounded-full animate-spin"></div>
      </div>
      <Typography variant="body1" className="text-primary-dark font-semi-bold">
        {message}
      </Typography>
    </Box>
  );
};

export default Loading;
